import { ComponentSingleStyleConfig } from '@chakra-ui/react'

export const Skeleton: ComponentSingleStyleConfig = {
  baseStyle: {
    w: 'full',
    h: '80px',
  },
}
